import { API_BASE } from './apiConfig'

/**
 * Language codes: AR = Arabic, EN = English
 */
export async function translateTexts(texts, target, source) {
  const list = (Array.isArray(texts) ? texts : [texts]).map((t) => String(t ?? ''))
  if (!list.length) return []

  const res = await fetch(`${API_BASE}/api/translate`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({
      texts: list,
      target,
      source,
    }),
  })

  const data = await res.json().catch(() => ({}))
  if (!res.ok) {
    throw new Error(data?.error?.message || 'Translation failed')
  }
  return Array.isArray(data.translations) ? data.translations : []
}

export async function translateText(text, target, source) {
  const [out] = await translateTexts([text], target, source)
  return out ?? text
}
